import React, {useState} from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import {MAIN_QUICK_ACTIONS} from '../constants';
import {
    aiAssistantActivateMainTextField,
    aiAssistantToggleMainActionUrlField
} from "../../../../../redux/slices/lomavisCreator/lomavisCreator";
import {InfoIconWithToolTip} from "../../include/InfoIconWithToolTip";


interface Props {
    t: (key: string) => string;
    dispatch: any;
}

const GenerateTextAction: React.FC<Props> = ({
                                                  t,
                                                  dispatch,
                                              }) => {
    const GENERATE_TEXT_ACTION = MAIN_QUICK_ACTIONS.find(
        (item) => item.action === 'generateText'
    );

    const onButtonClick = () => {

        dispatch(
            aiAssistantActivateMainTextField()
        )
    }


    // Card inner content re-used in both cases:
    const cardContent = (
        <>
            <div className="btn btn-secondary  btn-sm cursor-pointer" style={{whiteSpace: "nowrap"}}
                 onClick={onButtonClick}>
                <div className="d-flex flex-row align-items-center">
                    <div className="d-flex align-items-center">
                        <i className={`${GENERATE_TEXT_ACTION?.icon} me-2 w-20px`}/>
                    </div>
                    <div className="d-flex align-items-center">
                        {t(GENERATE_TEXT_ACTION?.name)}
                    </div>
                    <div className="d-flex align-items-center ps-2">
                        <InfoIconWithToolTip text={t("lomavisCreator.ai.quickActionFromUrl.generateText")}
                                             placement={"top"}/>
                    </div>
                </div>
            </div>
        </>
    );

    // If not enough tokens, wrap the entire card in the overlay.
    return (
        cardContent
    )
};

export default GenerateTextAction;
